import React from 'react';
import BrokerConnectionManager from '@/components/BrokerConnectionManager';

const BrokerConnections: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-1 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Broker Connections</h1>
          <BrokerConnectionManager />
        </div>
      </main>
    </div>
  );
};

export default BrokerConnections;
